import { css } from 'styled-components';

export const BlackBoxBase = css`
  border-radius: ${({ theme }) => theme.borderRadius.default};
  background: rgba(0, 0, 0, 0.48);
  color: ${({ theme }) => theme.colors.WHITE};
  display: inline-flex;
  align-items: center;
`;
